
import { Component, Vue } from 'vue-property-decorator'
import { Field } from '@/services/utils/baseForm'
import { popUpRoute } from '@/services/utils/popupRoute'
import { parsePathQueryString } from '@/shared/helpers/parsePathQueryString'
import eventBus from '@/eventBus'
import PreviewAvatar from '@/stories/preview-avatar/PreviewAvatar.vue'
import { freezeObject } from '@/shared/helpers/freezeObject'
import {
  IChannel,
  INotificationTrigger,
  TriggerStatus
} from '../types/triggerTypes'
import { notificationTriggerEndpoints } from '..'

@Component({
  name: 'TriggerStatusForm',
  components: {
    PreviewAvatar,
    BaseForm: () =>
      import(
        /* webpackChunkName : "BaseForm"*/ '@/stories/base-form/BaseForm.vue'
      ),
    DialogBaseSkeleton: () =>
      import(
        /* webpackChunkName : "DialogBaseSkeleton"*/ '@/stories/dialog-base-skeleton/DialogBaseSkeleton.vue'
      )
  }
})
export default class TriggerStatusForm extends Vue {
  loading = false
  data = {} as INotificationTrigger<IChannel>
  originalData = {} as INotificationTrigger<IChannel>

  async created() {
    await this.fetchRemoteData()
  }

  /** call given fetch data function */
  async fetchRemoteData() {
    const { id } = parsePathQueryString(location.search)
    this.loading = true
    try {
      if (id) this.data = await notificationTriggerEndpoints.get(id)
      this.originalData = freezeObject(this.data)
    } catch (error) {
      throw new Error(`Failed to fetch form data. Due to ${error}`)
    } finally {
      this.loading = false
    }
  }

  fields(): Field<INotificationTrigger>[] {
    return [
      Field.textarea<INotificationTrigger>('notes', 'notes').setProps({
        autoGrow: true,
        rows: 3
      })
    ]
  }

  /** submit the data to the desired endpoint.*/
  async handleSubmit(values: Pick<INotificationTrigger, 'notes'>) {
    const { id } = parsePathQueryString(location.search)
    if (id)
      await notificationTriggerEndpoints
        .changeTriggerStatus(
          this.data?.id,
          this.data.status === 'paused'
            ? TriggerStatus.RUNNING
            : TriggerStatus.PAUSED,
          values.notes
        )
        .then(() => this.closePopUp())
    eventBus.refreshData()
  }

  closePopUp() {
    popUpRoute.removeModalPath(['id'])
  }
}
